<template>
  <div class="page-component-wrapper">
    <page-panel-tabs
      :tabList="tabList"
      :activeTab.sync="currentTab"
    >
      <template v-slot:tab-item-title="{ tab }">
        <el-badge :value.sync="tab.badgeValue" :max="99" :hidden="!tab.badgeValue" class="dashboard-badge">
          <span :title="L10n(tab.name)">
            {{L10n(tab.name)}}
          </span>
        </el-badge>
      </template>
      <template v-slot:header>
        <h1 class="page-title">{{L10n($route.meta.label)}}</h1>
        <div class="dashboard-top row">
          <div class="col-xl-8">
            <links></links>
          </div>
          <div class="col-xl-4">
            <ul class="list-data">
              <li>
                <ul>
                  <li v-if="metaDisplay.displayKPIParts" class="dashboard-composite-item">
                <span>
                  <span class="name">{{L10n('parts-in-stock')}}</span>
                  <div class="d-flex">
                  <div class="result">{{partsInStock}}</div>
                  <div class="sub-result">
                    <div class="sub-result__value">{{totalParts}}</div>
                    <span class="name">{{L10n('of-parts')}}</span>
                  </div>
                </div>
                </span>
                  </li>
                  <li v-if="metaDisplay.displayKPICompanies" style="text-align: left">
                    <span class="name">{{L10n('companies')}}</span>
                    <div class="result">{{totalCompanies}}</div>
                  </li>
                  <li v-if="metaDisplay.displayKPIInvoices" class="dashboard-composite-item">
                <span>
                  <span class="name">{{L10n('sales-invoices')}}</span>
                  <div class="d-flex">
                  <div class="result">{{salesInvoices}}</div>
                  <div class="sub-result">
                    <div class="sub-result__value">{{totalInvoices}}</div>
                    <span class="name">{{L10n('of-invoices')}}</span>
                  </div>
                </div>
                </span>
                  </li>
                </ul>
              </li>
              <li class="dash-vertical-border" v-if="metaDisplay.displayKPIRFQs"></li>
              <li class="big" v-if="metaDisplay.displayKPIRFQs">
                <span class="name">{{L10n('rfqs')}}</span>
                <div class="result">{{totalRFQs}}</div>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-slot:tools>
        <tools-panel
          @onFilter="handlerFilter"
        ></tools-panel>
      </template>
      <template v-slot:content="{ tab }">
        <div
          v-for="(item, i) in tabList"
          :key="i"
          v-show="tab.name === item.name"
          style="height: 100%"
        >
          <component
            :is="item.componentName"
            :badgeValue.sync="item.badgeValue"
            :isFilterInit="isFiltersInit"
            :filters="filters"
          ></component>
        </div>
      </template>
    </page-panel-tabs>
  </div>
</template>

<script>

import { api } from '@/services/api'
export default {
  name: 'DashboardIndex',
  components: {
    'page-panel-tabs': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanelTabs'),
    'links': () => import(/* webpackChunkName: 'Dashboard' */ './Links'),
    'tools-panel': () => import(/* webpackChunkName: 'Dashboard' */ './ToolsPanel'),
    // TODO TABS
    'po-received-today': () => import(/* webpackChunkName: 'Dashboard' */ './POReceivedToday/Index'),
    'po-to-be-shipped-today-by-requested-day': () => import(/* webpackChunkName: 'Dashboard' */ './POToBeShippedTodayByRequestedDay/Index'),
    'part-shipped-today-to-customer-proforma-created': () => import(/* webpackChunkName: 'Dashboard' */ './PartShippedTodayToCustomerProformaCreated/Index'),
    'bax-supplier-po': () => import(/* webpackChunkName: 'Dashboard' */ './BAXSupplierPO/Index'),
    'parts-shipped-today-to-supplier': () => import(/* webpackChunkName: 'Dashboard' */ './PartsShippedTodayToSupplier/Index'),
    'invoice-issued-today': () => import(/* webpackChunkName: 'Dashboard' */ './InvoiceIssuedToday/Index'),
    'parts-qa-today': () => import(/* webpackChunkName: 'Dashboard' */ './PartsQaToday/Index'),
    'parts-to-be-received-from-suppliers': () => import(/* webpackChunkName: 'Dashboard' */ './PartsToBeReceivedFromSuppliers/Index')
  },
  created () {
    this.loadDashboardData()
  },
  computed: {
    externals () {
      return this.API('ExternalWebsites/GetAllDynamic?select=id,title,subTitle,image,linkURL')
    }
  },
  data () {
    return {
      currentTab: 'po-received-today',
      isFiltersInit: false,
      filters: {},
      tabList: [
        { componentName: 'po-received-today', name: 'po-received-today', badgeValue: 0 },
        { componentName: 'po-to-be-shipped-today-by-requested-day', name: 'po-to-be-shipped-today-by-requested-day', badgeValue: 0 },
        { componentName: 'part-shipped-today-to-customer-proforma-created', name: 'part-shipped-today-to-customer-proforma-created', badgeValue: 0 },
        { componentName: 'bax-supplier-po', name: 'bax-supplier-po', badgeValue: 0 },
        { componentName: 'parts-shipped-today-to-supplier', name: 'parts-shipped-today-to-supplier', badgeValue: 0 },
        { componentName: 'invoice-issued-today', name: 'invoice-issued-today', badgeValue: 0 },
        { componentName: 'parts-qa-today', name: 'parts-qa-today', badgeValue: 0 },
        { componentName: 'parts-to-be-received-from-suppliers', name: 'parts-to-be-received-from-suppliers', badgeValue: 0 }
      ],
      //
      dashboardGridCompanies: [],
      dashboardGridCompanyContacts: [],
      dashboardGridInvoices: [],
      dashboardGridStockItems: [],
      metaDisplay: {},
      partsInStock: null,
      salesInvoices: null,
      totalCompanies: null,
      totalInvoices: null,
      totalParts: null,
      totalRFQs: null
    }
  },
  methods: {
    handlerFilter (filters) {
      this.isFiltersInit = true
      this.$nextTick(() => {
        this.filters = { ...filters }
      })
    },
    loadDashboardData () {
      return api.get('Dashboards/GetDashboard')
        .then((response) => {
          let data = response.data
          let availableFields = [
            'dashboardGridCompanies', 'dashboardGridCompanyContacts', 'dashboardGridInvoices',
            'dashboardGridStockItems', 'metaDisplay', 'partsInStock',
            'salesInvoices', 'totalCompanies', 'totalInvoices', 'totalParts', 'totalRFQs'
          ]
          // set data to component (response.data -> $data)
          availableFields.forEach((fieldName) => {
            this[fieldName] = data[fieldName] || this[fieldName]
          })
        })
    }
  }
}
</script>

<style lang="stylus">
  .dash-vertical-border {
    border-left 1px solid #dcdfe6
  }
  .page-Dashboard {
    justify-content flex-end
    .content .grid-side .grid-head h1, body .grid-side .grid-head h1{
      padding 0
    }
    .dashboard-badge{
      overflow hidden
      height 100%
      width 100%
      text-overflow ellipsis
      .el-badge__content{
        right 0
        transform unset
    }
  }
    .sub_title {
      display block
      font-size 1.3rem
      font-weight normal
      color #bcbbbe
      margin 0 0 1.1rem
    }
    .dashboard-top {
      margin-top -2.5rem
      margin-bottom 2.5rem
      > div {
        padding-top: 2.5rem
      }
    }
    .list-data {
      list-style none
      margin 0
      display flex
      justify-content space-around
      width 100%
      max-width 57rem
      > li {
        display block
        text-align center
        vertical-align middle
        line-height 1.25
        &.big {
          .name {
            font-size 1.8rem
          }
          .result {
            font-size 4.8rem
            color #439b09
          }
        }
      }
      .dashboard-composite-item{
        display flex
        justify-content center
        .name{
          text-align left
        }
      }
      .name {
        font-size 1.2rem
        display block
        color #65646c
        font-weight normal
      }
      .result {
        font-size: 3.4rem
        color #09729b
      }
      .sub-result{
        padding-left 1rem
        display flex
        flex-direction column
        justify-content center
        text-align left
      }
      .sub-result__value{
        color #04ace7
        font-size 1.4rem
        font-weight bolder
      }
      ul {
        list-style none
        margin -0.9rem 0 0
        > li {
          padding 0.9rem 0 0
        }
      }
    }

    .dashboard-content {
      margin-top -2.5rem
      > div {
        padding-top: 2.5rem
      }
    }

    .border-box {
      background #fff
      border 1px solid #eeeeef
      border-radius 0.7rem
      padding 2.4rem 3rem 3rem
      min-height 100%
      .border-box-title {
        display flex
        align-items center
        justify-content space-between
        margin 0 0 1.5rem
        .link {
          font-size 1.2rem
          font-weight bold
          color #09729b
          text-transform uppercase
          margin 0.5rem 0
          white-space nowrap
        }
      }
      h2 {
        font-size 2rem
        color #65646c
        font-weight bold
        text-transform uppercase
        margin 0 0.5rem 0 0
      }
    }

    .row-simple-grid {
      list-style none
      margin 0
      border-bottom 1px solid #e7e7e9
      > li {
        border-top 1px solid #e7e7e9
        line-height 1.4
        padding 1.2rem 0 1rem
      }
      .name {
        display block
        font-size 1.4rem
        font-weight bold
        color #737279
        margin 0 0 0.3rem
        a {
          color #737279
        }
      }
      .date {
        display block
        font-size 1.2rem
        color rgba(101, 100, 108, 0.5)
      }
    }
}
@media only screen and (max-width: 1199px) {
  .page-Dashboard {
    .list-data {
      > li:first-child {
        border-left 0
      }
    }

  }
}

@media only screen and (max-width: 991px) {
  .page-Dashboard {
    .external-box {
      padding-right 0
      .external-button {
        position static
        transform translateY(0)
        margin 1rem 0 0
      }
    }
    .table-default {
      td
      th {
        padding-left 0.5rem
      }
    }
    .border-box {
      padding 2rem 1.5rem
    }
  }
}
@media only screen and (max-width: 767px) {
  .page-Dashboard {
    .content {
      width: 100%
    }
    .table-default {
      td
      th {
        font-size: 1.1rem
      }
    }

  }
}
</style>
